<article>
    <header>
      <strong>Ligações por Turnos</strong>
      <div class="sub-title">_</div>
    </header>
    <main>
      <app-bar-chart [loading]="isLoading" [error]="error"></app-bar-chart>
    </main>
  </article>
  